import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { useCallback } from 'react';
import { rootRoute } from '@/app/root-route.tsx';
import { type InboxSearch, inboxSearchSchema } from './search.ts';

const InboxPage = lazyRouteComponent(() => import('./InboxPage.tsx'), 'InboxPage');
const ConversationPage = lazyRouteComponent(
  () => import('./ConversationPage.tsx'),
  'ConversationPage',
);

export const inboxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inbox',
  validateSearch: (search: Record<string, unknown>): InboxSearch => inboxSearchSchema.parse(search),
  component: function InboxRouteComponent() {
    const search = inboxRoute.useSearch();
    const navigate = inboxRoute.useNavigate();
    const onSearchChange = useCallback(
      (patch: Partial<InboxSearch>) =>
        navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
      [navigate],
    );
    return <InboxPage search={search} onSearchChange={onSearchChange} />;
  },
});

export const conversationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/inbox/$conversationId',
  component: function ConversationRouteComponent() {
    const { conversationId } = conversationRoute.useParams();
    return <ConversationPage conversationId={conversationId} />;
  },
});

/** The Decisions page was replaced by the Service inbox; keeps old links working. */
export const legacyDecisionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/decisions',
  beforeLoad: () => {
    throw redirect({ to: '/inbox', replace: true });
  },
});
